import { useBlockNumber as useBlockNumberWmi } from "wagmi";

const useBlockNumber = () => useBlockNumberWmi();

export default useBlockNumber;
